import { datadogRum } from '@datadog/browser-rum';
import { useSelector } from 'react-redux';

const useDatadog = () => {
  const user = useSelector((state) => state.auth.user);

  if (process.env.REACT_APP_ENABLE_DATADOG === 'yes') {
    datadogRum.init({
      applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: process.env.REACT_APP_DATADOG_SERVICE,
      env: process.env.NODE_ENV || 'local',
      //  version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 25,
      trackInteractions: true,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
  }

  if (user) {
    datadogRum.setUser({
      id: user.id,
    });
    datadogRum.setGlobalContext({
      brand: {
        id: user?.current_brand?.id,
        name: user?.current_brand?.name,
      },
      platform: 'OMS',
    });
  }
};

export default useDatadog;
